<template>
	<div class="table-wrap">
		<template>
			<el-tabs @tab-click="handleClick">
				<el-tab-pane label="所有订单" name="0"></el-tab-pane>
				<el-tab-pane label="待支付" name="1"></el-tab-pane>
				<el-tab-pane label="充值中" name="2"></el-tab-pane>
				<el-tab-pane label="未提交" name="3"></el-tab-pane>
				<el-tab-pane label="充值成功" name="4"></el-tab-pane>
				<el-tab-pane label="已退款" name="5"></el-tab-pane>
				<el-tab-pane label="失败未退款" name="6"></el-tab-pane>
				<el-tab-pane label="部分成功" name="7"></el-tab-pane>
			</el-tabs>
		</template>
		<el-form :inline="true" :model="form" style="width: 70%;position: relative;">
			<el-row :gutter="15" style="width: 100%;">
				<el-col :span="8">
					<el-form-item label="订单号">
						<el-input v-model="form.orderNo" placeholder="请输入" clearable />
					</el-form-item>
				</el-col>

				<el-col :span="8">
					<el-form-item label="充值账号">
						<el-input v-model="form.chargeAccount" placeholder="请输入" clearable maxlength="30" />
					</el-form-item>
				</el-col>
				<el-col :span="6">
					<el-form-item label="充值渠道">
						<el-select v-model="form.orderSharerType" placeholder="请选择" clearable>
							<el-option v-for="(item,index) in $constant.RECHARGE_CHANNEL" :key="index"
								:label="item" :value="index">
							</el-option>
						</el-select>
					</el-form-item>
				</el-col>
				<el-col :span="8">
					<el-form-item label="下单时间">

						<el-date-picker v-model="payDate" type="daterange" range-separator="至"
							start-placeholder="开始日期" value-format="yyyy-MM-dd" format="yyyy-MM-dd"
							placeholder="请选择开始时间" end-placeholder="结束日期">
						</el-date-picker>

					</el-form-item>
				</el-col>
        <el-col :span="8">
          <el-form-item label="用户手机号">
            <el-input v-model="form.userTelnoLike" placeholder="请输入" clearable maxlength="11" />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="分享人手机号">
            <el-input v-model="form.sharerTelnoLike" placeholder="请输入" clearable maxlength="11" />
          </el-form-item>
        </el-col>
			</el-row>
			<el-row :gutter="20">
				<el-col :span="6">
					<el-form-item style="display: flex;">
						<el-button type="primary" @click="getOrderPage(1)" class="btn-m-top">查询</el-button>
						<el-button type="success" @click="exportList" class="btn-m-top-export">导出</el-button>
						<el-button type="success" @click="allSubmit" class="btn-m-top-export">批量提交</el-button>
					</el-form-item>
				</el-col>
			</el-row>


		</el-form>

		<template>
			<table border="1"
				style="border-collapse: collapse;text-align: center;width: 20%;float: right;z-index: 999;position:relative;left:-6%;margin-top: -280px;">
				<tr height="35">
					<td colspan="2" align="center">统计</td>
				</tr>
				<tr height="35">
					<td width="100">订单数</td>
					<td width="100">{{orderCount.orderNum}}</td>
				</tr>
				<tr height="35">
					<td width="100">订单金额</td>
					<td width="100">{{orderCount.orderAmountSum}}</td>
				</tr>
				<tr height="35">
					<td width="100">成功金额</td>
					<td width="100">{{orderCount.successAmountSum}}</td>
				</tr>
				<tr height="35">
					<td width="100">分享提成</td>
					<td width="100">{{orderCount.shareProfit}}</td>
				</tr>
				<tr height="35">
					<td width="100">利润</td>
					<td width="100">{{orderCount.platformProfit}}</td>
				</tr>
			</table>
			<el-table v-loading="orderObj.listLoading" :data="orderObj.list" element-loading-text="正在查询中..."
				highlight-current-row :row-key="(row) => { return row.id }" @selection-change="SelectionChange" >
				<el-table-column
				type="selection"
				:reserve-selection="true"
				width="55">
				</el-table-column>
				<el-table-column label="序号">
					<template slot-scope="scope">
						{{scope.$index + 1}}
					</template>
				</el-table-column>
				<el-table-column label="订单号" prop="orderNo" width="275" />
				<el-table-column label="充值渠道">
					<template slot-scope="scope">
						{{scope.row.orderSharerType | rechargeChannelFilter}}
					</template>
				</el-table-column>
        <el-table-column label="商品名称" prop="goodsTitle" v-if="form.orderType == 6" />
        <el-table-column v-if="form.orderType == 6" label="规格" prop="specification" width="250px">
        </el-table-column>
        <el-table-column label="运营商" prop="goodsTitle" v-if="form.orderType != 2 && form.orderType !=3 && form.orderType !=4 && form.orderType !=6" />
        <el-table-column label="商品金额" prop="facePrice" />
        <el-table-column label="归属地" prop="additionalInfo" v-if="form.orderType == 1" width="110"/>
				<el-table-column label="订单金额" prop="platformPrice" />
				<el-table-column label="分享提成" prop="shareProfit" />
				<el-table-column label="利润" prop="platformProfit" />
				<el-table-column label="充值用户" prop="userTelno" width="120" />
				<el-table-column label="被充值号码" v-if="form.orderType == 1 || form.orderType == 5 || form.orderType == 6" prop="account" width="220" />
<!--				<el-table-column label="被充值号码" v-if="form.orderType == 5" prop="account" width="220" />-->
<!--				<el-table-column label="被充值号码" v-else prop="account" width="120" />-->
				<el-table-column label="户号" prop="account" width="140" v-if="form.orderType==0 || form.orderType==3 || form.orderType==4" />
				<el-table-column label="充值信息" prop="additionalInfo" width="150" v-if="form.orderType==0" />
				<el-table-column label="充值信息" prop="additionalInfo" width="300" v-if="form.orderType==3 || form.orderType==4 " />
				<el-table-column label="充值信息" prop="additionalInfo" width="220" v-if="form.orderType==5" />
				<el-table-column label="支付时间" prop="payTime" width="160" />
				<el-table-column label="支付状态" width="90">
					<template slot-scope="scope">
						{{scope.row.payTime ?'已支付':'未支付'}}
					</template>
				</el-table-column>
        <el-table-column label="供货商" prop="goodsSupplierName" width="90" />
				<el-table-column label="订单状态" width="90">
					<template slot-scope="scope">
						{{scope.row.status | OrderStatusFilter}}
					</template>
				</el-table-column>
				<el-table-column label="提交状态" width="90">
					<template slot-scope="scope">
            <el-row v-if="scope.row.payTime == '' || scope.row.payTime == null">- -</el-row>
            <el-button v-else-if="scope.row.isSubmitVendor==1 && scope.row.status != 2 && scope.row.status !=3" type="primary" size="small"
            @click="onSubmit(scope.$index)">提交</el-button>
            <el-button v-else-if="scope.row.isSubmitVendor==0 && scope.row.vendorStatus == -1 && scope.row.status != 2 && scope.row.status !=3" type="primary" size="small"
            @click="onSubmit(scope.$index)">提交</el-button>
						<el-row v-else-if="scope.row.isSubmitVendor==2">
						{{scope.row.isSubmitVendor|SubmitStatus}}
						<el-button type="primary" size="small" v-if="scope.row.status !=3 && scope.row.status !=2"
							@click="onSubmit(scope.$index)">提交</el-button>
						</el-row>
						<el-row v-else>{{scope.row.isSubmitVendor|SubmitStatus}}</el-row>
					</template>
				</el-table-column>
				<el-table-column label="完成状态" prop="vendorStatusCN" width="90">
					<template slot-scope="scope">
						<el-row
							v-if="scope.row.payTime == '' || scope.row.payTime == null || scope.row.isSubmitVendor == 1 || scope.row.isSubmitVendor == 2">
							- -</el-row>
						<el-row v-else>{{scope.row.vendorStatusCN}}</el-row>
					</template>
				</el-table-column>
				<el-table-column label="退款状态" width="90">
					<template slot-scope="scope">
						<el-row
							v-if="scope.row.payTime == '' || scope.row.successAmount == scope.row.facePrice || scope.row.payTime == null || (scope.row.isSubmitVendor == 0 && (scope.row.vendorStatus == 0 || scope.row.vendorStatus == 1)) ">
							- -</el-row>
						<el-button v-else-if="scope.row.refundAmount==0 && scope.row.status !=3 " @click="onRefund(scope.$index)" size="small"
							type="primary">退款</el-button>
						<el-row v-else>已退款</el-row>
					</template>
				</el-table-column>
				<el-table-column label="补充值" width="90">
					<template slot-scope="scope">
						<el-row
							v-if="scope.row.payTime == '' || scope.row.payTime == null || scope.row.status == 3 || (scope.row.isSubmitVendor == 0 && (scope.row.vendorStatus == 0 || scope.row.vendorStatus == 1 || scope.row.vendorStatus == 200))">
							- -</el-row>
						<el-button v-else-if="scope.row.isOtherVendorRecharge == 1" size="small"
							@click="onChannel(scope.$index)" type="primary" round>完成</el-button>
						<el-row v-else>已完成</el-row>
					</template>
				</el-table-column>


				<el-table-column label="操作售后" width="140">
					<template slot-scope="scope">
						<el-button type="warning" size="mini" @click="gotoDetail(scope.row.id)">查看详情</el-button>
						<el-button type="warning" size="mini" @click="orderRemark(scope.$index)">备注</el-button>

					</template>
				</el-table-column>

        <el-table-column label="备注" prop="remark" width="240" />

			</el-table>

			<el-dialog :title="submitObj.dialogTitle" :visible.sync="submitObj.showDialog"
				v-loading="submitObj.dialogLoading" width="600px">
				<el-form ref="addForm" :model="submitObj" label-width="90px">
					<el-form-item label="订单" prop="orderNo">
						<el-input v-model="submitObj.form.orderNo" clearable disabled />
					</el-form-item>

					<el-form-item label="金额" prop="orderNo">
						<el-input v-model="submitObj.form.amount" disabled />
					</el-form-item>

					<el-form-item :label="submitObj.form.labelAccount" prop="account" v-if="submitObj.form.showAccount">
						<el-input v-model="submitObj.form.account" :maxlength="submitObj.form.maxlengthAccount" show-word-limit />
					</el-form-item>

					<el-form-item :label="submitObj.form.labelAccountName" prop="accountName" v-if="submitObj.form.showAccountName">
						<el-input v-model="submitObj.form.accountName" :maxlength="submitObj.form.maxlengthAccountName" show-word-limit />
					</el-form-item>

					<el-form-item label="电话号码" prop="accountTelno" v-if="submitObj.form.showAccountTelno">
						<el-input v-model="submitObj.form.accountTelno" maxlength="11" show-word-limit />
					</el-form-item>
					<el-form-item label="省份" prop="provinceId" v-if="submitObj.form.showProvince">
						<el-select v-model="provinceId" class="m-2" placeholder="选择省份" size="large" @change="getCityList(provinceId, submitObj.form.row_order_type)">
							<el-option
							v-for="item in provinceList"
							:key="item.id"
							:label="item.name"
							:value="item.id"
							/>
						</el-select>
					</el-form-item>

					<el-form-item label="城市" prop="cityId" v-if="submitObj.form.showCity">
							<el-select v-model="cityId" class="m-2" placeholder="选择城市" size="large" @change="getCompanyList(cityId, submitObj.form.row_order_type)">
								<el-option
								v-for="item in cityList"
								:key="item.id"
								:label="item.name"
								:value="item.id"
								/>
						</el-select>
					</el-form-item>

					<el-form-item :label="submitObj.form.labelCompany" prop="companyId" v-if="submitObj.form.showCompany">
						<el-select v-model="companyId" class="m-2" placeholder="选择公司" size="large" filterable>
							<el-option
							v-for="item in companyList"
							:key="item.id"
							:label="item.name"
							:value="item.id"
							/>
						</el-select>
					</el-form-item>

				</el-form>
				<span slot="footer" class="dialog-footer">
					<el-button type="primary" @click="submitOrder" style="width: 260px;height: 80px;">确 定</el-button>
				</span>
			</el-dialog>
			<!-- 退款 -->
			<el-dialog :title="refundObj.dialogTitle" :visible.sync="refundObj.showDialog"
				v-loading="submitObj.dialogLoading" width="600px">
				<el-form ref="addForm" :model="refundObj" label-width="90px">
					<el-form-item label="实际到账" prop="orderNo">
						<el-input v-model="refundObj.form.successAmount" clearable/>
					</el-form-item>
					<el-form-item label="退款金额" prop="orderNo">
						<el-input type="number" v-model="refundObj.form.refundAmount" @input="checkRefundMoney"
							maxlength="10" />
					</el-form-item>
					<el-form-item label="退款备注" prop="orderNo">
						<el-input type="textarea" rows="3" style="width: 350px;" v-model="refundObj.form.remark"
							placeholder="请输入备注" />
					</el-form-item>
				</el-form>
				<span slot="footer" class="dialog-footer">
					<el-button type="primary" @click="refund" style="width: 260px;height: 80px;">确 定</el-button>
				</span>
			</el-dialog>
			<!-- 其他渠道 -->
			<el-dialog :title="channelObj.dialogTitle" :visible.sync="channelObj.showDialog"
				v-loading="submitObj.dialogLoading" width="600px">
				<el-form label-width="90px">
					<el-form-item label="全部到账" prop="orderNo">
						<template>
							<el-radio v-model="channelObj.form.isAllSuccess" :label="0">是</el-radio>
							<el-radio v-model="channelObj.form.isAllSuccess" :label="1">否</el-radio>
						</template>
					</el-form-item>
					<el-form-item label="备注" prop="orderNo">
						<el-input type="textarea" rows="3" style="width: 350px;" v-model="channelObj.form.remark"
							placeholder="请输入备注" />
					</el-form-item>
				</el-form>
				<span slot="footer" class="dialog-footer">
					<el-button type="primary" @click="otherVendorRecharge" style="width: 260px;height: 80px;">确 定
					</el-button>
				</span>
			</el-dialog>
			<el-dialog :title="orderRemarkObj.dialogTitle" :visible.sync="orderRemarkObj.showDialog"
				v-loading="orderRemarkObj.dialogLoading" width="600px">
				<el-form label-width="90px">
				<el-form-item label="备注" prop="orderNo">
				<el-input type="textarea" rows="3" style="width: 350px;" v-model="orderRemarkObj.form.remark"
					placeholder="请输入备注" />
				</el-form-item>
				</el-form>
				<span slot="footer" class="dialog-footer">
					<el-button type="primary" @click="doOrderRemark" style="width: 260px;height: 80px;">确 定
					</el-button>
				</span>
			</el-dialog>
		</template>

		<Pagination :total="orderObj.total" :page.sync="form.pageNum" :limit.sync="form.pageSize" @pagination="getOrderPage"></Pagination>
	</div>
	<!-- 筛选end -->
	<!-- 提交 -->
</template>




<script>
	import {
		getOrderList,
		submitOrder,
		refund,
		otherVendorRecharge,
		exportOrderList,
		getOrderCount,
		batchSubmitVendor,
		orderRemark,
		getOrderRemark,
		getProvinces,
		getCitys,
		getCompanyList
	} from '@/api/order';

	import Pagination from '@/components/Pagination';
	import qs from 'qs'




	export default {
		name: 'Search',
		components: {
			Pagination
		},
		props: {
			orderObj: {
			  required: true,
			  type: Object
			},
			form: {
			  required: true,
			  type: Object
			},
			orderCount: {
				required: true,
				type: Object,
			},
			submitIds: {
				type: Array
			},
			dialogLoadingSubmit: {
				type: Boolean
			},
			refundObj: {
				type: Object
			},
			channelObj:{
				type: Object
			},
			submitObj:{
				type: Object
			},
			orderRemarkObj:{
				type: Object
			}
		},
		methods: {
			handleClick(tab, event){
				if(tab.name == 0){
					this.form.orderStatus = ''
				}else{
					this.form.orderStatus = tab.name - 1
				}
				this.form.pageNum=1
				this.getOrderPage()
			},
			exportList() {
				let loading = this.$loading({
					lock: true,
					text: '正在导出...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.7)'
				});

				exportOrderList({
					orderType:this.form.orderType,
					adminOrderStatus:this.form.adminOrderStatus,
					orderStatus:this.form.orderStatus,
					orderIdList: this.sonSubmitIds + '',
					createTimeStartYMDStr:this.form.createTimeStartYMDStr,
					createTimeEndYMDStr:this.form.createTimeEndYMDStr,
					orderNo:this.form.orderNo,
					chargeAccount:this.form.chargeAccount,
          userTelnoLike:this.form.userTelnoLike,
          sharerTelnoLike:this.form.sharerTelnoLike,
					orderSharerType:this.form.orderSharerType,
				}).then(res => {
					loading.close();
				}).catch(() => {
					loading.close();
				});
			},
			getOrderPage(type){
				let _this = this
				if(type == 1){
					_this.form.pageNum = 1
				}
				if(_this.payDate){
					_this.form.createTimeStartYMDStr = this.payDate[0]
					_this.form.createTimeEndYMDStr = this.payDate[1]
				}else{
					_this.form.createTimeStartYMDStr = ''
					_this.form.createTimeEndYMDStr = ''
				}
				_this.orderObj.listLoading = true;
				//获取订单列表
				getOrderList(_this.form).then(res => {
					_this.orderObj.list = res.data.list;
					_this.orderObj.total = res.data.total;
					_this.orderObj.listLoading = false;

				})
				//获取订单统计
				getOrderCount({
					orderType: this.form.orderType,
					createTimeStartYMDStr: _this.form.createTimeStartYMDStr,
					createTimeEndYMDStr: _this.form.createTimeEndYMDStr
				}).then(res => {
					if(res.code == 200){
						_this.orderCount.orderAmountSum = res.data.orderAmountSum
						_this.orderCount.orderNum = res.data.orderNum
						_this.orderCount.platformProfit = res.data.platformProfit
						_this.orderCount.shareProfit = res.data.shareProfit
						_this.orderCount.successAmountSum = res.data.successAmountSum
					}
				});
			},
			allSubmit(){
				if(this.sonSubmitIds.length == 0){
					this.$message.error('请选择提交订单')
					return
				}
				if(this.dialogLoadingSubmit == true){
					return
				}
				this.dialogLoadingSubmit =  true
				let _this = this

				_this.$throttle.canDoFunction({
				  key: "allSubmit",
				  time: 2000,
				  success: () => {
					  batchSubmitVendor({orderIdList:_this.sonSubmitIds}).then(res => {
              if(res.code == 200){
                _this.$message.success('提交成功');
              }else{
                _this.$message.error(res.message);
              }
					  	_this.dialogLoadingSubmit = false
					  	setTimeout(function(){
					  		_this.getOrderPage()
					  	}, 1000)
					  })
				  }
				});
			},
			SelectionChange(row){
				let _this = this

				if(row.length > 0){
					if(this.sonSubmitIds.length != 0){
						this.sonSubmitIds = []
					}

					row.forEach((item)=>{
						_this.sonSubmitIds.push(item.id)
					})
				}else{
					this.sonSubmitIds = []
				}
      },
			onRefund(i){
				this.refundObj.showDialog = true
				this.refundObj.form.orderId = this.orderObj.list[i].id
				this.refundObj.form.successAmount = this.orderObj.list[i].realPayAmount
				this.refundObj.form.refundAmount = this.orderObj.list[i].refundAmount
			},
			onSubmit(i){
				let _this = this
				_this.submitObj.showDialog = true
				//订单充值类型 订单类型：0-电费 1-话费 2-加油码 3-水费 4-燃气 5-加油卡 6-音视频
				let orderType = _this.orderObj.list[i].orderType
				//电费类型 3南网  2国网
				let goodsCategoryId = this.orderObj.list[i].goodsCategoryId
				//查询省份传参
				let provinceMap = {}
				console.log(orderType)
				console.log(goodsCategoryId)
				_this.submitObj.form.orderId = _this.orderObj.list[i].id
				_this.submitObj.form.orderNo = _this.orderObj.list[i].orderNo
				_this.submitObj.form.amount  = _this.orderObj.list[i].realPayAmount
				console.log(_this.orderObj.list[i])
				switch (orderType) {
					case 0:
						_this.submitObj.form.showAccount = true
						_this.submitObj.form.showProvince = true
						_this.submitObj.form.showCity = true

						_this.submitObj.form.labelAccount = '充值账号'
						_this.submitObj.form.maxlengthAccount = 30

						provinceMap = {type:0}

						if (goodsCategoryId == 3) {
							provinceMap = {type:1}
							//南网需要显示
							_this.submitObj.form.showAccountName = true
							_this.submitObj.form.labelAccountName = '身份证后6位'
							_this.submitObj.form.maxlengthAccountName = 6
							this.$set(this.submitObj.form, 'accountName', _this.orderObj.list[i].accountName)
						}

						this.$set(this.submitObj.form, 'account', _this.orderObj.list[i].account)
						_this.provinceId = _this.orderObj.list[i].provinceId

						_this.getCityList(_this.provinceId, orderType)
						_this.cityId = _this.orderObj.list[i].cityId

						break;
					case 1:
						_this.submitObj.form.showAccount = true

						_this.submitObj.form.labelAccount = '充值账号'
						_this.submitObj.form.maxlengthAccount = 11

						this.$set(this.submitObj.form, 'account', _this.orderObj.list[i].account)
						break;
          case 6:
            _this.submitObj.form.showAccount = true

            _this.submitObj.form.labelAccount = '充值账号'
            _this.submitObj.form.maxlengthAccount = 11

            this.$set(this.submitObj.form, 'account', _this.orderObj.list[i].account)
            break;
					case 3:
						_this.submitObj.form.showAccount = true
						_this.submitObj.form.showAccountName = true
						_this.submitObj.form.showProvince = true
						_this.submitObj.form.showCity = true
						_this.submitObj.form.showCompany = true

						_this.submitObj.form.labelAccount = '户号'
						_this.submitObj.form.maxlengthAccount = 50
						_this.submitObj.form.labelAccountName = '户名'
						_this.submitObj.form.maxlengthAccountName = 50
						_this.submitObj.form.labelCompany = '水费公司'


						this.$set(this.submitObj.form, 'account', _this.orderObj.list[i].account)
						this.$set(this.submitObj.form, 'accountName', _this.orderObj.list[i].accountName)
						_this.provinceId = _this.orderObj.list[i].provinceId

						_this.getCityList(_this.provinceId, orderType)
						_this.cityId = _this.orderObj.list[i].cityId

						_this.getCompanyList(_this.cityId, orderType)
						_this.companyId = _this.orderObj.list[i].companyId

						break;
					case 4:
						_this.submitObj.form.showAccount = true
						_this.submitObj.form.showAccountName = true
						_this.submitObj.form.showProvince = true
						_this.submitObj.form.showCity = true
						_this.submitObj.form.showCompany = true

						_this.submitObj.form.labelAccount = '户号'
						_this.submitObj.form.maxlengthAccount = 30
						_this.submitObj.form.labelAccountName = '户名'
						_this.submitObj.form.maxlengthAccountName = 50
						_this.submitObj.form.labelCompany = '气费公司'



						this.$set(this.submitObj.form, 'account', _this.orderObj.list[i].account)
						this.$set(this.submitObj.form, 'accountName', _this.orderObj.list[i].accountName)
						_this.provinceId = _this.orderObj.list[i].provinceId

						_this.getCityList(_this.provinceId, orderType)
						_this.cityId = _this.orderObj.list[i].cityId

						_this.getCompanyList(_this.cityId, orderType)
						_this.companyId = _this.orderObj.list[i].companyId
						break;
					case 5:
						_this.submitObj.form.showAccount = true
						_this.submitObj.form.showAccountName = true
						_this.submitObj.form.showAccountTelno = true

						_this.submitObj.form.labelAccount = '充值账号'
						_this.submitObj.form.maxlengthAccount = 30

						_this.submitObj.form.labelAccountName = '姓名'
						_this.submitObj.form.maxlengthAccountName = 50


						this.$set(this.submitObj.form, 'account', _this.orderObj.list[i].account)
						this.$set(this.submitObj.form, 'accountName', _this.orderObj.list[i].accountName)
						this.$set(this.submitObj.form, 'accountTelno', _this.orderObj.list[i].accountTelno)

						break;
				}

				_this.submitObj.form.row_order_type = orderType
				_this.submitObj.form.goods_category_id = goodsCategoryId

				//获取省份
				getProvinces(orderType, provinceMap).then(res => {
					if(res.code == 200){
						_this.provinceList = res.data
					}
				});
			},
			getOrderRemark(id){
				let _this = this
				_this.$throttle.canDoFunction({
				  key: "getOrderRemark",
				  time: 2000,
				  success: () => {
					  getOrderRemark(
						 {
						  orderId: id,
						 }
					  ).then(res => {
						_this.orderRemarkObj.form.remark = res.data
					  })
				  }
				})
			},
			orderRemark(i){
				this.orderRemarkObj.showDialog = true
				this.orderRemarkObj.form.orderId = this.orderObj.list[i].id
				this.getOrderRemark(this.orderObj.list[i].id)
			},
			doOrderRemark(){
				let _this = this
				_this.$throttle.canDoFunction({
				  key: "orderRemark",
				  time: 2000,
				  success: () => {
					  orderRemark(
						 {
						  orderId: _this.orderRemarkObj.form.orderId,
						  remark: _this.orderRemarkObj.form.remark,
						 }
					  ).then(res => {
					  	_this.$message.success('已提交');
					  	_this.dialogLoadingSubmit = false;
						this.orderRemarkObj.showDialog = false
					  	setTimeout(function(){
					  		_this.getOrderPage()
					  	}, 1000)
					  })
				  }
				});
			},
			//跳转详情
			gotoDetail(id) {
				this.$router.push('orderDetail?id='+id)
			},
			onChannel(i){
				this.channelObj.showDialog = true
				this.channelObj.form.orderId = this.orderObj.list[i].id
				this.channelObj.form.isAllSuccess = 1
			},
			// 其他渠道
			otherVendorRecharge(i){
				let _this = this
				this.channelObj.showDialog = false
				otherVendorRecharge(this.channelObj.form).then(res => {
					if(res.code == 200){
						setTimeout(function(){
							_this.getOrderPage()
						}, 1000)
						_this.$message.success("提交成功");
						_this.refresh()
					}else{
						_this.$message.error(res.message);
					}
				})
			},
			//提交订单
			submitOrder(i) {
				let _this = this
				_this.submitObj.showDialog = false
				let param = {
					orderId: _this.submitObj.form.orderId,
					account: _this.submitObj.form.account ?  _this.submitObj.form.account : null,
					accountName: _this.submitObj.form.accountName ?  _this.submitObj.form.accountName : null,
					accountTelno: _this.submitObj.form.accountTelno ? _this.submitObj.form.accountTelno : null,
					cityId: _this.cityId ? _this.cityId : null,
					companyId: _this.companyId ? _this.companyId : null
				}
				submitOrder(param).then(res => {
					if(res.code == 200){
						setTimeout(function(){
							_this.getOrderPage()
						}, 1000)
						_this.$message.success('提交成功');
					}else{
						_this.$message.error(res.message);
					}
				});
			},
			checkRefundMoney(){
				// if(parseFloat(this.refundObj.form.refundAmount) > parseFloat(this.refundObj.form.successAmount)){
				// 	this.refundObj.form.refundAmount = this.refundObj.form.successAmount
				// }
			},
			//退款
			refund(i){
				let _this=this;
				this.refundObj.showDialog = false
				// if(this.refundObj.form.refundAmount > this.refundObj.form.successAmount){
				// 	this.$message.error('退款金额不能大于实际到账')
				// }
				refund(this.refundObj.form).then(res => {
					if(res.code == 200){
						setTimeout(function(){
							_this.getOrderPage()
						}, 1000)
						_this.$message.success("提交成功");
					}else{
						_this.$message.error(res.message);
					}
				})
			},
			getCityList(i, type){

				console.log(i)
				console.log(type)
				let _this = this
				_this.cityList = []
				_this.cityId = ''
				_this.companyList = []
				_this.companyId = ''
				//获取省份
				getCitys(type, {provinceId:i}).then(res => {
					console.log(res.data)
					if(res.code == 200){
						_this.cityList = res.data
					}
				});
			},
			getCompanyList(i, type){
				let _this = this
				_this.companyList = []
				_this.companyId = ''
				//获取省份
				getCompanyList(type, {cityId:i}).then(res => {
					console.log(res.data)
					if(res.code == 200){
						_this.companyList = res.data
					}
				});
			},
		},
		filters: {
			rechargeChannelFilter(type) { //充值渠道
				return {
					0:'系统',
					1:'社团长'
				}[type]
			},
			OrderStatusFilter(type) { //订单状态
				return {
					0:'待支付',
					1:'充值中',
					2:'充值完成',
					3:'已退款',
					4:'已取消'
				}[type]
			},
			SubmitStatus(type) { //账户状态
				return {
					0: '提交成功',
					1: '未提交',
					2: '提交失败',
				}[type]
			},
			StatusType(type) { //账户状态
				return {
					0:'是',
					1:'否'
				}[type]
			},
		},

		data() {
			return {
				sonSubmitIds: [

				],
				payDate: [],
				value: '',
				provinceList: [], //获取省数组数据
       			cityList: [], //获取市数组数据
				provinceId: "",
				cityId: "",
				companyList: [], //公司
				companyId: ""

			}
		}
	}
</script>
